import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../locales/en';
import ru from '../locales/ru';

// Определяем начальный язык из localStorage
// const initialLanguage = localStorage.getItem('appLanguage') || 'en';
const initialLanguage = 'en';

// Собираем ресурсы с namespace
const buildResources = () => {
  const result = {};
  const languages = { en, ru };
  Object.entries(languages).forEach(([lng, modules]) => {
    result[lng] = {};
    Object.entries(modules).forEach(([namespace, data]) => {
      result[lng][namespace] = data;
    });
  });
  return result;
};

const resources = buildResources();

// Оборачиваем инициализацию i18n в проверку, чтобы избежать повторной инициализации
if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources,
    lng: initialLanguage,
    fallbackLng: 'en',
    ns: Object.keys(en),
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
      wait: true,
    },
  });

  // Функция для сохранения языка в localStorage при его изменении
  i18n.on('languageChanged', (lng) => {
    localStorage.setItem('appLanguage', lng);
  });
}

export default i18n;
